<!-- Notes App Source file: src/app/_components/edit/edit.component.html -->
<alert></alert>
<app-config class="hidden" />
<p-confirmDialog></p-confirmDialog>

<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<div class="!bg-surface">
  <div class="flex" *ngIf="isLoading()">
    <div class="m-4 text-red-500 text-2xl">Loading page...</div>
    <div class="my-4 spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>

  <ng-container *ngIf="!isLoading()">
    <div class="edit-shell">
      <div class="edit-appbar">
        <p-menu
          class="page-menu"
          [model]="menuItems"
          #menu
          [popup]="true"
          [style]="{
            borderRadius: '12px',
            border: '1px solid var(--p-surface-border)',
            padding: '10px',
            boxShadow: '0px 18px 30px rgba(15, 23, 42, 0.18)'
          }" />
        <div class="edit-appbar-inner">
          <div class="edit-appbar-left">
            <p-button text class="edit-icon-button" (click)="menu.toggle($event)">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">menu</span>
              </ng-template>
            </p-button>
            <div class="edit-title">
              {{ note.Title || 'Untitled note' }}
            </div>
          </div>
          <div class="edit-appbar-actions">
            <p-button text class="edit-icon-button edit-icon-button--favorite" (click)="toggleFavorite()">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined" [ngClass]="{ 'is-filled': isFavorite }">
                  {{ isFavorite ? 'favorite' : 'favorite_border' }}
                </span>
              </ng-template>
            </p-button>
            <p-button
              text
              class="edit-icon-button hidden lg:inline-flex"
              icon="pi pi-sparkles"
              (click)="openAskNotes()"
              ariaLabel="Ask Notes"
              [title]="!isOnline ? 'AI features are only available in online mode' : 'Ask Notes'"
              [disabled]="!isOnline">
            </p-button>
            <p-button text class="edit-icon-button" data-action="home" (click)="pageMenu('Home')">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">home</span>
              </ng-template>
            </p-button>
            <p-button text class="edit-icon-button" (click)="pageMenu('View')">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">visibility</span>
              </ng-template>
            </p-button>
            <p-button text class="edit-icon-button" data-action="pdf" (click)="pageMenu('DownloadPDF')">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">picture_as_pdf</span>
              </ng-template>
            </p-button>
            <p-button text class="edit-icon-button" data-action="print" (click)="pageMenu('Print')">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">print</span>
              </ng-template>
            </p-button>
            <p-button text class="edit-icon-button" (click)="pageMenu('Close')">
              <ng-template pTemplate="icon">
                <span class="material-symbols-outlined">close</span>
              </ng-template>
            </p-button>
          </div>
        </div>
      </div>

      <div class="edit-content">
        <form *ngIf="editNoteForm" [formGroup]="editNoteForm">
          <div class="">
            <div class="" *ngIf="note">
              <div class="flex w-full m-0 items-center edit-title-row-wrap">
                <div class="group relative flex p-1 h-10 w-full gap-3 edit-title-row">
                  <div class="bold flex p-1 text-red-900 edit-title-label">Title</div>
                  <input
                    #TitleField
                    class="w-full bold p-1 border bg-surface-0 text-surface-700 dark:text-surface-100 edit-title-input"
                    [ngClass]="{ '!border-2 !border-red-500 bg-red-50': f['Title'].invalid && f['Title'].touched }"
                    type="text"
                    formControlName="Title"
                    (ngModelChange)="onOtherContentChanged($event)" />
                  <button
                    class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 border-0 bg-transparent"
                    type="button"
                    (click)="clearTitle()">
                    <i class="fas fa-times text-red-500"></i>
                  </button>
                </div>
              </div>

              <section class="edit-section edit-section--metadata">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleHeaderFields()">
                  <div class="edit-section-title">Metadata</div>
                  <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleHeaderFields()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{
                        isHeaderVisible ? 'expand_less' : 'expand_more'
                      }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div class="edit-card" *ngIf="isHeaderVisible">
                  <div class="edit-meta-grid edit-meta-grid--core">
                    <div class="edit-meta-item">
                      <div class="edit-meta-label">ID</div>
                      <div class="edit-meta-value edit-meta-value--with-action">
                        <span class="edit-meta-value__text">{{ note._id }}</span>
                        <p-button text class="edit-meta-copy-button" (click)="copyNoteId()" aria-label="Copy ID">
                          <ng-template pTemplate="icon">
                            <span class="material-symbols-outlined">content_copy</span>
                          </ng-template>
                        </p-button>
                      </div>
                    </div>
                    <div class="edit-meta-item">
                      <div class="edit-meta-label">Status</div>
                      <div class="edit-meta-value">
                        <select
                          class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100"
                          id="Status"
                          formControlName="Status"
                          (change)="onOtherContentChanged($event)"
                          name="Status">
                          <option *ngFor="let status of statusValues" [selected]="note && status === note.Status">
                            {{ status }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="edit-meta-item">
                      <div class="edit-meta-label">Type</div>
                      <div class="edit-meta-value">
                        <select
                          class="w-full p-1 border border-[var(--borderColor)]"
                          id="NoteType"
                          formControlName="NoteType"
                          (change)="onOtherContentChanged($event)"
                          name="NoteType">
                          <option *ngFor="let type of types" [ngValue]="type">
                            {{ type }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="edit-meta-item">
                      <div class="edit-meta-label">Reference Date</div>
                      <div class="edit-meta-value">
                        <p-datepicker
                          inputId="ReferenceDate"
                          formControlName="ReferenceDate"
                          [showIcon]="true"
                          iconDisplay="input"
                          [appendTo]="'body'"
                          [showButtonBar]="true"
                          dateFormat="dd.mm.yy"
                          class="w-full"
                          (onSelect)="onOtherContentChanged($event)">
                        </p-datepicker>
                      </div>
                    </div>

                    <div class="edit-meta-item" *ngIf="isEventType">
                      <div class="edit-meta-label">Start Date</div>
                      <div class="edit-meta-value">
                        <p-datepicker
                          inputId="StartDate"
                          formControlName="StartDate"
                          [showIcon]="true"
                          iconDisplay="input"
                          [showTime]="true"
                          hourFormat="24"
                          [appendTo]="'body'"
                          [showButtonBar]="true"
                          dateFormat="dd.mm.yy"
                          class="w-full"
                          (onSelect)="onOtherContentChanged($event)">
                        </p-datepicker>
                      </div>
                    </div>

                    <div class="edit-meta-item" *ngIf="isEventType">
                      <div class="edit-meta-label">End Date</div>
                      <div class="edit-meta-value">
                        <p-datepicker
                          inputId="EndDate"
                          formControlName="EndDate"
                          [showIcon]="true"
                          iconDisplay="input"
                          [showTime]="true"
                          hourFormat="24"
                          [appendTo]="'body'"
                          [showButtonBar]="true"
                          dateFormat="dd.mm.yy"
                          class="w-full"
                          (onSelect)="onOtherContentChanged($event)">
                        </p-datepicker>
                      </div>
                    </div>

                  </div>

                  <button class="edit-more-toggle-row" type="button" (click)="toggleMetadataMore()" [attr.aria-expanded]="isMetadataMoreVisible">
                    <span class="edit-more-toggle-line"></span>
                    <span class="edit-more-toggle-label">
                      {{ isMetadataMoreVisible ? 'Less' : 'More' }}
                      <i [class]="isMetadataMoreVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
                    </span>
                    <span class="edit-more-toggle-line"></span>
                  </button>

                  <div class="edit-meta-grid" *ngIf="isMetadataMoreVisible">
                    <div class="edit-meta-item" *ngIf="!isEventType">
                      <div class="edit-meta-label">Start Date</div>
                      <div class="edit-meta-value">
                        <p-datepicker
                          inputId="StartDate"
                          formControlName="StartDate"
                          [showIcon]="true"
                          iconDisplay="input"
                          [showTime]="true"
                          hourFormat="24"
                          [appendTo]="'body'"
                          [showButtonBar]="true"
                          dateFormat="dd.mm.yy"
                          class="w-full"
                          (onSelect)="onOtherContentChanged($event)">
                        </p-datepicker>
                      </div>
                    </div>

                    <div class="edit-meta-item" *ngIf="!isEventType">
                      <div class="edit-meta-label">End Date</div>
                      <div class="edit-meta-value">
                        <p-datepicker
                          inputId="EndDate"
                          formControlName="EndDate"
                          [showIcon]="true"
                          iconDisplay="input"
                          [showTime]="true"
                          hourFormat="24"
                          [appendTo]="'body'"
                          [showButtonBar]="true"
                          dateFormat="dd.mm.yy"
                          class="w-full"
                          (onSelect)="onOtherContentChanged($event)">
                        </p-datepicker>
                      </div>
                    </div>

                    <div class="edit-meta-item">
                      <div class="edit-meta-label">Categories</div>
                      <div class="edit-meta-value">
                        <p-treeSelect
                          class="w-full border bg-white !border-[var(--borderColor)] h-[2.5em] custom-treeselect"
                          formControlName="Categories"
                          [options]="categories_tree"
                          placeholder="Select one or more categories"
                          selectionMode="checkbox"
                          [propagateSelectionDown]="false"
                          [propagateSelectionUp]="false"
                          appendTo="body"
                          panelStyleClass="edit-categories-panel"
                          [overlayOptions]="{ appendTo: 'body', autoZIndex: true, baseZIndex: 12000 }"
                          display="chip"
                          [filter]="true"
                          [metaKeySelection]="false"
                          [panelStyle]="{ 'max-height': '400px', 'overflow-y': 'auto' }">
                        </p-treeSelect>
                      </div>
                    </div>

                    <div class="edit-meta-item">
                      <div class="edit-meta-label">Confidential</div>
                      <div class="edit-meta-value">
                        <label class="flex items-center gap-2">
                          <input
                            type="checkbox"
                            formControlName="Confidential"
                            (change)="onOtherContentChanged($event)" />
                          <span class="text-sm text-surface-700 dark:text-surface-100">Yes</span>
                        </label>
                      </div>
                    </div>
                    <div class="edit-meta-item edit-meta-item--muted">
                      <div class="edit-meta-label">Created</div>
                      <div class="edit-meta-value">{{ note.created_on | date : 'dd.MMM.yyyy HH:mm' }}</div>
                    </div>
                    <div class="edit-meta-item edit-meta-item--muted">
                      <div class="edit-meta-label">Modified</div>
                      <div class="edit-meta-value">{{ note.last_modified | date : 'dd.MMM.yyyy HH:mm' }}</div>
                    </div>
                    <div class="edit-meta-item edit-meta-item--muted">
                      <div class="edit-meta-label">Sync-Time</div>
                      <div class="edit-meta-value">{{ note.syncTime | date : 'dd.MMM.yyyy HH:mm' }}</div>
                    </div>
                    <div class="edit-meta-item edit-meta-item--muted">
                      <div class="edit-meta-label">Sync-Status</div>
                      <div class="edit-meta-value">{{ note.syncStatus }}</div>
                    </div>
                    <div class="edit-meta-item edit-meta-item--muted">
                      <div class="edit-meta-label">Note Size</div>
                      <div class="edit-meta-value">{{ noteSizeLabel }}</div>
                    </div>
                  </div>

                  <ng-container *ngIf="isMetadataMoreVisible">
                    <div class="edit-ai-summary-section" *ngIf="!aiSummary">
                      <div class="edit-more-toggle-row" style="cursor: default;">
                        <span class="edit-more-toggle-line"></span>
                        <span class="edit-more-toggle-label">AI Summary</span>
                        <span class="edit-more-toggle-line"></span>
                      </div>
                      <div class="edit-ai-summary-actions">
                        <p-button
                          [label]="aiSummaryButtonLabel"
                          icon="pi pi-sparkles"
                          size="small"
                          [loading]="aiSummaryLoading"
                          [disabled]="aiSummaryLoading || !isOnline"
                          [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                          (onClick)="generateAiSummary()">
                        </p-button>
                      </div>
                      <div class="edit-meta-item edit-meta-item--full">
                        <div class="edit-meta-value edit-meta-value--full">AI-Summary information is not available for this note.</div>
                      </div>
                    </div>

                    <div class="edit-ai-summary-section" *ngIf="aiSummary as summary">
                      <div class="edit-more-toggle-row" style="cursor: default;">
                        <span class="edit-more-toggle-line"></span>
                        <span class="edit-more-toggle-label">AI Summary</span>
                        <span class="edit-more-toggle-line"></span>
                      </div>
                      <div class="edit-ai-summary-actions">
                        <p-button
                          [label]="aiSummaryButtonLabel"
                          icon="pi pi-sparkles"
                          size="small"
                          [loading]="aiSummaryLoading"
                          [disabled]="aiSummaryLoading || !isOnline"
                          [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                          (onClick)="generateAiSummary()">
                        </p-button>
                      </div>

                      <div class="edit-meta-grid">
                        <div class="edit-meta-item">
                          <div class="edit-meta-label">Status</div>
                          <div class="edit-meta-value">
                            <span class="edit-ai-summary-status">
                              <span
                                class="material-symbols-outlined edit-ai-summary-icon"
                                [ngClass]="aiSummaryStatusIconClass(summary.summary_status)">
                                {{ aiSummaryStatusIcon(summary.summary_status) }}
                              </span>
                              {{ aiSummaryStatusLabel(summary.summary_status) }}
                            </span>
                          </div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_stale">
                          <div class="edit-meta-label">Stale</div>
                          <div class="edit-meta-value">Yes</div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_model">
                          <div class="edit-meta-label">Model</div>
                          <div class="edit-meta-value">{{ summary.summary_model }}</div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_note_revision">
                          <div class="edit-meta-label">Rev</div>
                          <div class="edit-meta-value">{{ summary.summary_note_revision }}</div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_requested_at">
                          <div class="edit-meta-label">Requested</div>
                          <div class="edit-meta-value">{{ summary.summary_requested_at | date : 'dd.MMM.yyyy HH:mm' }}</div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_generated_at">
                          <div class="edit-meta-label">Generated</div>
                          <div class="edit-meta-value">{{ summary.summary_generated_at | date : 'dd.MMM.yyyy HH:mm' }}</div>
                        </div>

                        <div class="edit-meta-item" *ngIf="summary.summary_token_input || summary.summary_token_output">
                          <div class="edit-meta-label">Tokens</div>
                          <div class="edit-meta-value">{{ summary.summary_token_input ?? '—' }} in / {{ summary.summary_token_output ?? '—' }} out</div>
                        </div>
                      </div>

                      <div class="edit-ai-summary-full-fields">
                        <div class="edit-meta-item edit-meta-item--full" *ngIf="summary.summary_error">
                          <div class="edit-meta-label">Error</div>
                          <div class="edit-meta-value edit-meta-value--full edit-meta-value--multiline">{{ summary.summary_error }}</div>
                        </div>

                        <div class="edit-meta-item edit-meta-item--full" *ngIf="summary.summary_one_sentence">
                          <div class="edit-meta-label">Summary</div>
                          <div class="edit-meta-value edit-meta-value--full edit-meta-value--multiline">{{ summary.summary_one_sentence }}</div>
                        </div>

                        <div class="edit-meta-item edit-meta-item--full" *ngIf="summary.summary_paragraph">
                          <div class="edit-meta-label">Paragraph</div>
                          <div class="edit-meta-value edit-meta-value--full edit-meta-value--multiline">{{ summary.summary_paragraph }}</div>
                        </div>

                        <div class="edit-meta-item edit-meta-item--full" *ngIf="summary.summary_bullets?.length">
                          <div class="edit-meta-label">Bullets</div>
                          <div class="edit-meta-value edit-meta-value--full edit-meta-value--multiline">
                            <ul class="edit-ai-summary-bullets">
                              <li *ngFor="let bullet of summary.summary_bullets">{{ bullet }}</li>
                            </ul>
                          </div>
                        </div>

                        <div class="edit-meta-item edit-meta-item--full" *ngIf="summary.summary_keywords?.length">
                          <div class="edit-meta-label">Keywords</div>
                          <div class="edit-meta-value edit-meta-value--full edit-meta-value--multiline">{{ summary.summary_keywords!.join(', ') }}</div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </section>

              <section class="edit-section edit-section--description">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleDescription()">
                  <div class="edit-section-title">Description</div>
                  <div style="display: flex; gap: 0.25rem; align-items: center;">
                    <p-button 
                      text 
                      class="edit-toggle-button" 
                      [title]="areAllCollapsibleExpanded ? 'Collapse All Sections' : 'Expand All Sections'"
                      (click)="$event.stopPropagation(); toggleAllCollapsibleSections()">
                      <ng-template pTemplate="icon">
                        <span class="material-symbols-outlined">{{ areAllCollapsibleExpanded ? 'unfold_less' : 'unfold_more' }}</span>
                      </ng-template>
                    </p-button>
                    <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleDescription()">
                      <ng-template pTemplate="icon">
                        <span class="material-symbols-outlined">{{
                          isDescriptionExpanded ? 'expand_less' : 'expand_more'
                        }}</span>
                      </ng-template>
                    </p-button>
                  </div>
                </div>
                <div class="block w-full min-w-0 edit-section-body edit-section-body--description" style="position: relative" *ngIf="isDescriptionExpanded">
                  <app-rich-editor
                    #descriptionEditor
                    class="block w-full min-w-0"
                    editorId="EditDescription"
                    [noteId]="note._id || noteId || null"
                    [readOnly]="false"
                    [placeholderText]="''"
                    [content]="editNoteForm.get('DescriptionHtml')?.value"
                    (saveShortcutTriggered)="handleSaveShortcut()"
                    (contentUpdated)="onEditorHtmlContentUpdated('Description', $event)"
                    (noteLinkInserted)="onNoteLinkInserted($event)">
                  </app-rich-editor>
                </div>
              </section>

              <section class="edit-section edit-section--attachments">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleFileAttachments()">
                  <div class="edit-section-title-wrap">
                    <div class="edit-section-title">File Attachments</div>
                    <span
                      class="edit-section-count-badge"
                      [ngClass]="{ 'edit-section-count-badge--active': attachmentCount > 0 }"
                      [attr.aria-label]="attachmentCount + ' attachments'">{{ attachmentCount }}</span>
                  </div>
                  <p-button
                    text
                    class="edit-toggle-button"
                    (click)="$event.stopPropagation(); toggleFileAttachments()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{
                        isFileAttachmentsExpanded ? 'expand_less' : 'expand_more'
                      }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div class="block w-full m-0 items-center mb-4 edit-section-body edit-section-body--attachments" [class.hidden]="!isFileAttachmentsExpanded">
                  <app-file-upload [noteForm]="editNoteForm" [noteId]="note._id" [noteAttachments]="note.Attachments" [readOnly]="false"> </app-file-upload>
                </div>
              </section>

              <section class="edit-section edit-section--tags">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleTags()">
                  <div class="edit-section-title-wrap">
                    <div class="edit-section-title">Tags</div>
                    <span
                      class="edit-section-count-badge"
                      [ngClass]="{ 'edit-section-count-badge--active': tagCount > 0 }"
                      [attr.aria-label]="tagCount + ' tags'">{{ tagCount }}</span>
                  </div>
                  <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleTags()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{
                        isTagsExpanded ? 'expand_less' : 'expand_more'
                      }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div class="flex w-full m-0 items-center edit-section-body edit-section-body--tags" *ngIf="isTagsExpanded">

                  <!-- Mobile layout (<768px) -->
                  <div class="flex md:hidden flex-col gap-1.5 p-1 w-full edit-tags-layout-mobile">
                    <div class="flex flex-wrap gap-1" *ngIf="noteTags.length > 0">
                      <p-chip
                        *ngFor="let tag of noteTags; let i = index"
                        [label]="tag.isActive ? tag.name : (tag.name + ' ·')"
                        [removable]="true"
                        [style]="getTagChipStyle(tag)"
                        [styleClass]="tag.isActive ? 'cursor-pointer border edit-tag-chip edit-tag-chip--mobile' : 'cursor-pointer border edit-tag-chip edit-tag-chip--mobile edit-tag-chip--inactive'"
                        (click)="openEditTagDialog(tag, i)"
                        (onRemove)="$event.stopPropagation(); detachTagAt(i)">
                      </p-chip>
                    </div>
                    <div class="flex gap-1.5 items-center">
                      <p-autocomplete
                        #quickTagAutocomplete
                        class="flex-1 min-w-0 edit-tag-autocomplete"
                        [(ngModel)]="quickTagName"
                        [ngModelOptions]="{ standalone: true }"
                        [suggestions]="filteredTagSuggestions"
                        [dropdown]="true"
                        panelStyleClass="edit-tag-autocomplete-panel"
                        scrollHeight="26rem"
                        [appendTo]="'body'"
                        optionLabel="name"
                        placeholder="Add tag…"
                        (onFocus)="showAvailableTagSuggestions()"
                        (completeMethod)="searchTagSuggestions($event)"
                        (onSelect)="onTagAutocompleteSelected($event)"
                        (keydown.enter)="$event.preventDefault(); addQuickTag()">
                        <ng-template let-tag pTemplate="item">
                          <div class="edit-tag-suggestion" [ngClass]="{ 'edit-tag-suggestion--inactive': !tag.isActive }">
                            <span
                              class="edit-tag-suggestion__swatch"
                              [style.backgroundColor]="tag.color || '#94a3b8'">
                            </span>
                            <div class="edit-tag-suggestion__meta">
                              <div class="edit-tag-suggestion__name">{{ tag.name }}</div>
                              <div class="edit-tag-suggestion__detail">{{ tag.tagType }} · {{ tag.slug }}</div>
                            </div>
                            <span class="edit-tag-suggestion__status" [ngClass]="{ 'is-inactive': !tag.isActive }">
                              {{ getTagStatusLabel(tag) }}
                            </span>
                          </div>
                        </ng-template>
                      </p-autocomplete>
                      <p-button
                        label="Add"
                        size="small"
                        styleClass="edit-tags-mobile-btn"
                        [loading]="isTagMutating"
                        (onClick)="addQuickTag()"
                        [disabled]="!quickTagInputText.trim() || isTagMutating">
                      </p-button>
                      <p-button
                        label="Manage"
                        icon="pi pi-tags"
                        size="small"
                        styleClass="edit-tags-mobile-btn edit-tags-mobile-btn--new"
                        (onClick)="openTagManager()">
                      </p-button>
                      <p-button
                        label="Generate"
                        icon="pi pi-sparkles"
                        size="small"
                        styleClass="edit-tags-mobile-btn"
                        [loading]="aiSuggestTagsLoading"
                        [disabled]="aiSuggestTagsLoading || !isOnline"
                        [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                        (onClick)="generateSuggestedTags()">
                      </p-button>
                    </div>
                    <ng-container *ngIf="noteTags.length === 0">
                      <div class="text-xs text-surface-400 dark:text-surface-300 pl-0.5">
                        No tags yet.
                      </div>
                    </ng-container>
                  </div>

                  <!-- Desktop layout (≥768px) — unchanged -->
                  <div class="hidden md:flex p-1 w-full gap-3 items-start edit-tags-layout">
                    <div class="w-32 bold left-0 p-1 text-red-900 flex flex-col gap-2">
                      <span>Tags</span>
                      <p-button
                        label="Manage Tags"
                        icon="pi pi-tags"
                        size="small"
                        (onClick)="openTagManager()">
                      </p-button>
                      <p-button
                        label="Generate"
                        icon="pi pi-sparkles"
                        size="small"
                        [loading]="aiSuggestTagsLoading"
                        [disabled]="aiSuggestTagsLoading || !isOnline"
                        [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                        (onClick)="generateSuggestedTags()">
                      </p-button>
                    </div>
                    <div class="flex-1 flex flex-col gap-3">
                      <div class="flex flex-wrap gap-2" *ngIf="noteTags.length > 0">
                        <p-chip
                          *ngFor="let tag of noteTags; let i = index"
                          [label]="getTagChipLabel(tag)"
                          [removable]="true"
                          [style]="getTagChipStyle(tag)"
                          [styleClass]="tag.isActive ? 'cursor-pointer border edit-tag-chip' : 'cursor-pointer border edit-tag-chip edit-tag-chip--inactive'"
                          (click)="openEditTagDialog(tag, i)"
                          (onRemove)="$event.stopPropagation(); detachTagAt(i)">
                        </p-chip>
                      </div>
                      <div class="flex gap-2 flex-wrap items-center">
                        <p-autocomplete
                          #quickTagAutocomplete
                          class="flex-1 min-w-[12rem] edit-tag-autocomplete"
                          [(ngModel)]="quickTagName"
                          [ngModelOptions]="{ standalone: true }"
                          [suggestions]="filteredTagSuggestions"
                          [dropdown]="true"
                          panelStyleClass="edit-tag-autocomplete-panel"
                          scrollHeight="26rem"
                          [appendTo]="'body'"
                          optionLabel="name"
                          placeholder="Search existing tags or create a new one"
                          (onFocus)="showAvailableTagSuggestions()"
                          (completeMethod)="searchTagSuggestions($event)"
                          (onSelect)="onTagAutocompleteSelected($event)"
                          (keydown.enter)="$event.preventDefault(); addQuickTag()">
                          <ng-template let-tag pTemplate="item">
                            <div class="edit-tag-suggestion" [ngClass]="{ 'edit-tag-suggestion--inactive': !tag.isActive }">
                              <span
                                class="edit-tag-suggestion__swatch"
                                [style.backgroundColor]="tag.color || '#94a3b8'">
                              </span>
                              <div class="edit-tag-suggestion__meta">
                                <div class="edit-tag-suggestion__name">{{ tag.name }}</div>
                                <div class="edit-tag-suggestion__detail">{{ tag.tagType }} · {{ tag.slug }}</div>
                              </div>
                              <span class="edit-tag-suggestion__status" [ngClass]="{ 'is-inactive': !tag.isActive }">
                                {{ getTagStatusLabel(tag) }}
                              </span>
                            </div>
                          </ng-template>
                        </p-autocomplete>
                        <p-button
                          label="Add"
                          icon="pi pi-plus"
                          size="small"
                          [loading]="isTagMutating"
                          (onClick)="addQuickTag()"
                          [disabled]="!quickTagInputText.trim() || isTagMutating">
                        </p-button>
                      </div>

                      <ng-container *ngIf="noteTags.length === 0">
                        <div class="text-sm text-surface-500 dark:text-surface-300">
                          No tags yet. Add one to organize this note.
                        </div>
                      </ng-container>
                    </div>
                  </div>

                </div>
              </section>

              <section class="edit-section edit-section--keywords">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleKeywords()">
                  <div class="edit-section-title">Keywords</div>
                  <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleKeywords()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{
                        isKeywordsExpanded ? 'expand_less' : 'expand_more'
                      }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div class="flex w-full m-0 items-center edit-section-body edit-section-body--keywords" *ngIf="isKeywordsExpanded">
                  <div class="flex p-1 w-full gap-3 items-start edit-keywords-layout">
                    <div class="w-32 bold left-0 p-1 text-red-900 flex flex-col gap-2">
                      <span>Keywords</span>
                      <p-button
                        label="Generate"
                        icon="pi pi-sparkles"
                        size="small"
                        [loading]="aiKeywordsLoading"
                        [disabled]="aiKeywordsLoading || !isOnline"
                        [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                        (onClick)="generateKeywords()">
                      </p-button>
                    </div>
                    <div class="flex-1 flex flex-col gap-2">
                      <input
                        class="w-full p-1 border bg-surface-0 text-surface-700 dark:text-surface-100"
                        id="Keywords"
                        formControlName="Keywords"
                        (change)="onOtherContentChanged($event)"
                        name="Keywords" />
                      <div class="flex items-center gap-2">
                        <label class="w-32 bold left-0 text-red-900" for="AiKeywords">AI Keywords</label>
                        <input
                          class="flex-1 p-1 border bg-surface-0 text-surface-700 dark:text-surface-100"
                          id="AiKeywords"
                          formControlName="AiKeywords"
                          name="AiKeywords"
                          [readonly]="aiKeywordsLoading" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Related Notes -->
              <section class="edit-section edit-section--related-notes">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleRelatedNotes()">
                  <div class="edit-section-title-wrap">
                    <div class="edit-section-title">Related Notes</div>
                    <span
                      class="edit-section-count-badge"
                      [ngClass]="{ 'edit-section-count-badge--active': relatedNotes.length > 0 }">
                      {{ relatedNotes.length }}
                    </span>
                  </div>
                  <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleRelatedNotes()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{ isRelatedNotesExpanded ? 'expand_less' : 'expand_more' }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div *ngIf="isRelatedNotesExpanded" class="edit-section-body px-1">
                  <p-table
                    *ngIf="relatedNotes.length > 0"
                    [value]="relatedNoteObjects"
                    styleClass="p-datatable-sm"
                    [scrollable]="true"
                    scrollHeight="280px">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width:10%"></th>
                        <th style="width:32%">Title</th>
                        <th style="width:14%">Status</th>
                        <th style="width:20%">Modified</th>
                        <th style="width:12%">AI Summary</th>
                        <th style="width:8%"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-ref let-i="rowIndex">
                      <tr [ngStyle]="relatedNoteRowStyle(ref.status)">
                        <td class="text-center whitespace-nowrap">
                          <p-button
                            icon="pi pi-chevron-up"
                            text
                            size="small"
                            styleClass="edit-related-move-btn"
                            title="Move up"
                            [disabled]="i === 0"
                            (click)="$event.stopPropagation()"
                            (onClick)="moveRelatedNote(i, -1)"></p-button>
                          <p-button
                            icon="pi pi-chevron-down"
                            text
                            size="small"
                            styleClass="edit-related-move-btn"
                            title="Move down"
                            [disabled]="i === relatedNotes.length - 1"
                            (click)="$event.stopPropagation()"
                            (onClick)="moveRelatedNote(i, 1)"></p-button>
                        </td>
                        <td [ngStyle]="relatedNoteRowStyle(ref.status)">
                          <a class="hover:underline cursor-pointer"
                            [ngStyle]="relatedNoteRowStyle(ref.status)"
                            [routerLink]="['/view', ref.id]"
                            target="_blank"
                            rel="noopener">
                            {{ ref.title || '(Untitled)' }}
                          </a>
                        </td>
                        <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(ref.status)">{{ ref.status || '—' }}</td>
                        <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(ref.status)">
                          {{ ref.lastModified ? (ref.lastModified | date:'dd MMM yyyy') : '—' }}
                        </td>
                        <td class="text-center">
                          <ng-container [ngSwitch]="ref.aiSummary?.summary_status">
                            <span *ngSwitchCase="'current'"
                              class="material-symbols-outlined view-ai-summary-icon"
                              [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                              tooltipPosition="left"
                              [tooltipOptions]="{ showDelay: 200, tooltipStyleClass: 'view-ai-summary-tooltip' }">
                              info
                            </span>
                            <span *ngSwitchCase="'stale'"
                              class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--stale"
                              [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                              tooltipPosition="left"
                              [tooltipOptions]="{ showDelay: 200, tooltipStyleClass: 'view-ai-summary-tooltip' }">
                              info
                            </span>
                            <span *ngSwitchCase="'pending'"
                              class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--pending"
                              [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                              tooltipPosition="left">
                              pending
                            </span>
                            <span *ngSwitchCase="'failed'"
                              class="material-symbols-outlined view-ai-summary-icon view-ai-summary-icon--failed"
                              [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                              tooltipPosition="left">
                              error_outline
                            </span>
                          </ng-container>
                        </td>
                        <td>
                          <p-button
                            icon="pi pi-trash"
                            text
                            severity="danger"
                            size="small"
                            title="Remove"
                            (click)="logRelatedNoteTrashClick(i); $event.stopPropagation()"
                            (onClick)="requestRemoveRelatedNote(i)"></p-button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                  <div *ngIf="relatedNotes.length === 0" class="text-sm text-surface-400 dark:text-surface-300 py-2">
                    No related notes linked yet.
                  </div>
                  <div class="flex gap-2 flex-wrap mt-3">
                    <p-button
                      label="Add Related Note"
                      icon="pi pi-link"
                      size="small"
                      (onClick)="openAddRelatedNoteDialog()"></p-button>
                    <p-button
                      label="Find Similar"
                      icon="pi pi-sparkles"
                      size="small"
                      severity="secondary"
                      [loading]="similarForLinkLoading"
                      [disabled]="!note._id || !isOnline"
                      [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                      (onClick)="openFindSimilarForLink()"></p-button>
                  </div>
                </div>
              </section>

              <section class="edit-section">
                <div class="edit-section-header edit-section-header--toggle" (click)="toggleComments()">
                  <div class="edit-section-title">Comments</div>
                  <p-button text class="edit-toggle-button" (click)="$event.stopPropagation(); toggleComments()">
                    <ng-template pTemplate="icon">
                      <span class="material-symbols-outlined">{{ isCommentsExpanded ? 'expand_less' : 'expand_more' }}</span>
                    </ng-template>
                  </p-button>
                </div>
                <div class="block w-full min-w-0" *ngIf="isCommentsExpanded">
                  <app-rich-editor
                    class="block w-full min-w-0"
                    editorId="EditComments"
                    [noteId]="note._id || noteId || null"
                    [readOnly]="false"
                    [placeholderText]="''"
                    [content]="editNoteForm.get('CommentsHtml')?.value"
                    (saveShortcutTriggered)="handleSaveShortcut()"
                    (contentUpdated)="onEditorHtmlContentUpdated('Comments', $event)">
                  </app-rich-editor>
                </div>
              </section>
            </div>
          </div>
        </form>
      </div>

      <!-- FOOTER - show Save / Cancel buttons, fixed at bottom-->
      <div class="edit-footer !bg-red-100 text-xl border p-0.5 z-50 fixed bottom-0 w-full">
        <div class="flex items-center justify-between flex-nowrap">
          <div class="flex items-center gap-4 flex-nowrap">
            <div class="flex gap-2 flex-nowrap">
              <ng-container *ngIf="!autosaveEnabled">
                <p-button
                  icon="pi pi-save"
                  (click)="pageMenu('SaveNote')"
                  label="Save"
                  [disabled]="isSaving"
                  class="edit-footer-action-button hidden sm:inline-flex"></p-button>
                <p-button
                  icon="pi pi-save"
                  (click)="pageMenu('SaveNoteAndView')"
                  label="Save & View"
                  [disabled]="isSaving"
                  class="edit-footer-action-button hidden sm:inline-flex"></p-button>
                <p-button
                  icon="pi pi-save"
                  (click)="pageMenu('SaveNoteAndClose')"
                  label="Save & Close"
                  [disabled]="isSaving"
                  class="edit-footer-action-button"></p-button>
              </ng-container>
              <p-button
                *ngIf="autosaveEnabled"
                icon="pi pi-eye"
                (click)="pageMenu('View')"
                label="View"
                severity="secondary"
                class="edit-footer-action-button hidden sm:inline-flex"></p-button>
              <p-splitButton
                *ngIf="autosaveEnabled"
                icon="pi pi-times-circle"
                (onClick)="cancelEdits()"
                [model]="closeSplitMenuItems"
                severity="secondary"
                label="Close"
                styleClass="edit-footer-action-button edit-footer-close-split"></p-splitButton>
              <p-button
                *ngIf="!autosaveEnabled"
                icon="pi pi-times-circle"
                (click)="cancelEdits()"
                severity="secondary"
                label="{{ isContentChanged ? 'Cancel' : 'Close' }}"
                class="edit-footer-action-button"></p-button>
              <p-button
                icon="pi pi-sparkles"
                (click)="findSimilarNotes()"
                label="Find Similar"
                severity="secondary"
                [loading]="similarNotesLoading"
                [disabled]="similarNotesLoading || !note._id || !isOnline"
                [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                class="edit-footer-action-button hidden lg:inline-flex"></p-button>
            </div>

            <div class="flex gap-2 flex-nowrap">
              <button
                #trigger
                pButton
                type="button"
                icon="pi pi-search-plus"
                class="edit-footer-icon-button p-button-text p-button-rounded !text-primary-600 dark:!text-primary-300"
                (click)="overlay?.toggle($event)"></button>

              <p-popover
                #overlay
                [dismissable]="true"
                appendTo="body"
                position="top"
                class="z-overlay translate-y-[-5rem]">
                <div class="p-1 w-56 flex flex-col gap-2">
                  <label class="text-sm font-semibold">Editor Zoom</label>
                  <p-slider
                    [(ngModel)]="editorZoomFactor"
                    [min]="50"
                    [max]="400"
                    [step]="1"
                    (onChange)="onZoomFactorChange('editor', editorZoomFactor)"
                    (onSlideEnd)="persistEditorZoom()">
                  </p-slider>
                  <div class="text-center text-sm">{{ editorZoomFactor }}%</div>
                </div>
              </p-popover>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <!-- When autosave is on, its own status icon already reflects connectivity
                 (saved / saved-local-awaiting-sync / sync-failed / etc.), so showing the
                 plain connectivity icon too just duplicated it (two green "cloud" icons
                 while online). Only show the plain indicator when autosave is off. -->
            <span
              *ngIf="!autosaveEnabled"
              class="edit-footer-online-indicator"
              [ngClass]="{ 'online': connectivity.fullyOnline, 'offline': !connectivity.fullyOnline }"
              [attr.aria-label]="connectivity.label"
              [title]="connectivity.label">
              <span class="material-symbols-outlined edit-footer-status-icon"
                [ngClass]="connectivity.fullyOnline ? 'edit-footer-status-icon--online' : 'edit-footer-status-icon--offline'">{{ connectivity.icon }}</span>
            </span>
            <span
              *ngIf="autosaveEnabled"
              class="edit-footer-online-indicator autosave-status"
              [ngClass]="autosaveStatusView.colorClass"
              [attr.aria-label]="autosaveStatusView.label"
              [title]="autosaveStatusView.label">
              <span
                class="material-symbols-outlined edit-footer-status-icon"
                [ngClass]="{ 'autosave-status-icon--spin': autosaveStatusView.spin }"
                aria-hidden="true">{{ autosaveStatusView.icon }}</span>
              <span class="hidden sm:inline pr-2.5">{{ autosaveStatusView.label }}</span>
            </span>
            <div *ngIf="!autosaveEnabled" class="text-sm truncate flex items-center gap-1"
              [ngClass]="isContentChanged ? 'text-red-600 font-bold' : 'text-gray-600'">
              <span *ngIf="isContentChanged" class="material-symbols-outlined text-base" aria-hidden="true">warning</span>
              <span class="hidden sm:inline pr-2.5">{{ statusMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Unsaved Changes Confirmation Dialog -->
    <p-dialog
      header="Unsaved Changes"
      [(visible)]="unsavedChangesDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px', maxWidth: '92vw' }"
      [showHeader]="true"
      styleClass="unsaved-changes-dialog"
      appendTo="body"
      [closeOnEscape]="false"
      [closable]="false">
      <div class="flex items-start gap-3">
        <span class="material-symbols-outlined text-4xl text-yellow-500 flex-shrink-0">warning</span>
        <div class="flex flex-col gap-2">
          <p class="text-base font-semibold text-surface-900 dark:text-surface-0 m-0">
            You have unsaved changes
          </p>
          <p class="text-sm text-surface-600 dark:text-surface-300 m-0">
            If you leave without saving, your changes will be lost. Are you sure you want to discard them?
          </p>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            label="Keep Editing"
            severity="secondary"
            icon="pi pi-arrow-left"
            (onClick)="onCancelDiscard()"></p-button>
          <p-button
            label="Discard Changes"
            severity="danger"
            icon="pi pi-trash"
            (onClick)="onConfirmDiscard()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Save as Template Dialog -->
    <p-dialog
      header="Save as Template"
      [(visible)]="saveTemplateDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px', maxWidth: '92vw' }"
      appendTo="body">
      <div class="flex flex-col gap-2">
        <label for="templateName" class="text-sm font-semibold">Template Name</label>
        <input
          id="templateName"
          pInputText
          type="text"
          [(ngModel)]="templateName"
          (blur)="templateNameTouched = true"
          placeholder="Enter a template name"
          class="w-full" />
        <small *ngIf="templateNameTouched && !templateName.trim()" class="text-red-600">
          Template name is required.
        </small>
      </div>
      <ng-template pTemplate="footer">
        <p-button
          label="Cancel"
          severity="secondary"
          icon="pi pi-times"
          (onClick)="saveTemplateDialogVisible = false"></p-button>
        <p-button
          label="Save Template"
          icon="pi pi-save"
          [loading]="isSavingTemplate"
          [disabled]="!templateName.trim()"
          (onClick)="saveTemplateFromDialog()"></p-button>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="Tag Details"
      [(visible)]="tagDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '560px', maxWidth: '94vw' }"
      appendTo="body">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1 sm:col-span-2">
          <label for="tagName" class="text-sm font-semibold">Name</label>
          <input
            id="tagName"
            pInputText
            type="text"
            [(ngModel)]="tagDraftName"
            [ngModelOptions]="{ standalone: true }"
            (input)="onTagNameDraftChanged()"
            placeholder="Angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagType" class="text-sm font-semibold">Tag Type</label>
          <p-select
            inputId="tagType"
            [options]="tagTypeOptions"
            [(ngModel)]="tagDraftType"
            [ngModelOptions]="{ standalone: true }"
            [editable]="false"
            placeholder="Select tag type"
            class="w-full">
          </p-select>
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagSlug" class="text-sm font-semibold">Slug</label>
          <input
            id="tagSlug"
            pInputText
            type="text"
            [(ngModel)]="tagDraftSlug"
            [ngModelOptions]="{ standalone: true }"
            placeholder="angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagColor" class="text-sm font-semibold">Color</label>
          <input
            id="tagColor"
            pInputText
            type="text"
            [(ngModel)]="tagDraftColor"
            [ngModelOptions]="{ standalone: true }"
            placeholder="#DD0031"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagIcon" class="text-sm font-semibold">Icon</label>
          <input
            id="tagIcon"
            pInputText
            type="text"
            [(ngModel)]="tagDraftIcon"
            [ngModelOptions]="{ standalone: true }"
            placeholder="angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1 sm:col-span-2">
          <label for="tagParentTagId" class="text-sm font-semibold">Parent Tag</label>
          <div class="flex gap-2 items-center">
            <p-autocomplete
              inputId="tagParentTagId"
              class="flex-1 edit-tag-autocomplete"
              [(ngModel)]="tagDraftParentTag"
              [ngModelOptions]="{ standalone: true }"
              [suggestions]="filteredParentTagSuggestions"
              [dropdown]="true"
              [appendTo]="'body'"
              optionLabel="name"
              placeholder="Optional parent tag"
              (completeMethod)="searchParentTagSuggestions($event)"
              (onSelect)="onParentTagSelected($event)"
              (ngModelChange)="onParentTagInputChanged($event)">
              <ng-template let-tag pTemplate="item">
                <div class="edit-tag-suggestion" [ngClass]="{ 'edit-tag-suggestion--inactive': !tag.isActive }">
                  <span
                    class="edit-tag-suggestion__swatch"
                    [style.backgroundColor]="tag.color || '#94a3b8'">
                  </span>
                  <div class="edit-tag-suggestion__meta">
                    <div class="edit-tag-suggestion__name">{{ tag.name }}</div>
                    <div class="edit-tag-suggestion__detail">{{ tag.tagType }} · {{ tag.slug }}</div>
                  </div>
                  <span class="edit-tag-suggestion__status" [ngClass]="{ 'is-inactive': !tag.isActive }">
                    {{ getTagStatusLabel(tag) }}
                  </span>
                </div>
              </ng-template>
            </p-autocomplete>
            <p-button
              icon="pi pi-times"
              severity="secondary"
              text
              [disabled]="!parentTagInputText"
              (onClick)="clearParentTag()">
            </p-button>
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagSortOrder" class="text-sm font-semibold">Sort Order</label>
          <input
            id="tagSortOrder"
            pInputText
            type="number"
            [(ngModel)]="tagDraftSortOrder"
            [ngModelOptions]="{ standalone: true }"
            placeholder="10"
            class="w-full" />
        </div>

        <label class="flex items-center gap-2 sm:col-span-2 mt-1">
          <input
            type="checkbox"
            [(ngModel)]="tagDraftIsActive"
            [ngModelOptions]="{ standalone: true }" />
          <span class="text-sm text-surface-700 dark:text-surface-100">Tag is active</span>
        </label>
      </div>

      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            *ngIf="editingTagIndex !== null"
            label="Delete"
            severity="danger"
            icon="pi pi-trash"
            [loading]="isTagMutating"
            (onClick)="deleteTagAt(editingTagIndex!)"></p-button>
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            [disabled]="isTagMutating"
            (onClick)="tagDialogVisible = false"></p-button>
          <p-button
            label="Save Tag"
            icon="pi pi-check"
            [loading]="isTagMutating"
            [disabled]="!tagDraftName.trim() || isTagMutating"
            (onClick)="saveTagDialog()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="AI Suggested Tags"
      [(visible)]="aiSuggestTagsDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '760px', maxWidth: '96vw' }"
      appendTo="body">
      <div class="mb-3 text-sm text-surface-600 dark:text-surface-300">
        Choose which suggested tags should be added to this note.
      </div>

      <p-table
        [value]="aiSuggestedTags"
        styleClass="p-datatable-sm"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '36rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5rem;">Add</th>
            <th style="width: 12rem;">Name</th>
            <th>Description</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-suggested>
          <tr>
            <td>
              <input
                type="checkbox"
                [(ngModel)]="suggested.selected"
                [ngModelOptions]="{ standalone: true }"
                [attr.aria-label]="'Select tag ' + suggested.name" />
            </td>
            <td class="font-semibold">{{ suggested.name }}</td>
            <td>{{ suggested.description || '—' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center py-5 text-surface-500 dark:text-surface-300">
              No fitting tags were suggested for this note.
            </td>
          </tr>
        </ng-template>
      </p-table>

      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="cancelSuggestedTagsDialog()"></p-button>
          <p-button
            label="Add selected Tags"
            icon="pi pi-check"
            [disabled]="!hasSelectedSuggestedTags"
            (onClick)="addSelectedSuggestedTags()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Add Related Note Dialog -->
    <p-dialog
      header="Add Related Note"
      [(visible)]="addRelatedNoteDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '680px', maxWidth: '96vw' }"
      appendTo="body"
      (onHide)="relatedNoteSearchQuery = ''; relatedNoteSearchResults = []">
      <div class="flex flex-col gap-3 pt-1">
        <input
          pInputText
          type="text"
          class="w-full"
          placeholder="Search notes by title or ID…"
          [(ngModel)]="relatedNoteSearchQuery"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onRelatedNoteSearch()" />
        <div *ngIf="!relatedNoteSearchQuery.trim()" class="text-sm text-surface-400 dark:text-surface-300 py-2">
          Start typing to search notes.
        </div>
        <p-table
          *ngIf="relatedNoteSearchQuery.trim()"
          [value]="relatedNoteSearchResults"
          styleClass="p-datatable-sm"
          [scrollable]="true"
          scrollHeight="320px">
          <ng-template pTemplate="header">
            <tr>
              <th>Title</th>
              <th class="text-xs" style="width:40%">Note ID</th>
              <th style="width:18%">Modified</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-n>
            <tr class="cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800" (click)="selectRelatedNote(n)">
              <td class="font-medium">{{ n.Title || '(Untitled)' }}</td>
              <td class="text-xs text-surface-400 truncate max-w-xs" [title]="n._id">{{ n._id }}</td>
              <td class="text-sm text-surface-400 whitespace-nowrap">{{ n.last_modified | date:'dd MMM yyyy' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center py-5 text-surface-400">No matching notes found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          <label class="inline-flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300 sm:mr-auto">
            <input
              type="checkbox"
              [(ngModel)]="addRelatedNoteCreateBacklink"
              [ngModelOptions]="{ standalone: true }" />
            <span>Add backlink</span>
          </label>
          <p-button
            label="Close"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="addRelatedNoteDialogVisible = false"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Find Similar Notes to Link Dialog -->
    <p-dialog
      header="Find Similar Notes to Link"
      [(visible)]="similarForLinkDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '70vw', maxWidth: '900px' }"
      [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
      appendTo="body">
      <ng-template pTemplate="content">
        <div *ngIf="similarForLinkError" class="text-red-600 mb-3 text-sm">{{ similarForLinkError }}</div>
        <p-table
          [value]="similarForLinkResults"
          [loading]="similarForLinkLoading"
          styleClass="p-datatable-sm"
          [paginator]="similarForLinkResults.length > 15"
          [rows]="15">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:4rem">Link</th>
              <th style="width:30%">Title</th>
              <th style="width:18%">Status</th>
              <th style="width:18%">Modified</th>
              <th style="width:10%">Score</th>
              <th style="width:4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [ngStyle]="relatedNoteRowStyle(item.Status || '')">
              <td>
                <input
                  type="checkbox"
                  [(ngModel)]="item.selected"
                  [ngModelOptions]="{ standalone: true }" />
              </td>
              <td [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ item.title || '—' }}</td>
              <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ item.Status || '—' }}</td>
              <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ formatSimilarForLinkDate(item) }}</td>
              <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">
                {{ item.final_score != null ? (item.final_score | number:'1.2-2') : '' }}
              </td>
              <td class="text-center">
                <a pButton
                  icon="pi pi-eye"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  [routerLink]="['/view', getSimilarForLinkNoteId(item)]"
                  target="_blank"
                  rel="noopener"
                  pTooltip="View note"
                  tooltipPosition="left"></a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-surface-400 py-6">
                <span *ngIf="!similarForLinkLoading">No similar notes found.</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          <label class="inline-flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300 sm:mr-auto">
            <input
              type="checkbox"
              [(ngModel)]="createBacklinksChecked"
              [ngModelOptions]="{ standalone: true }" />
            <span>Create Backlinks</span>
          </label>
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="similarForLinkDialogVisible = false"></p-button>
          <p-button
            label="Link Selected"
            icon="pi pi-link"
            [disabled]="!hasSelectedSimilarForLink || similarForLinkLoading"
            (onClick)="linkSelectedSimilarNotes()"></p-button>
        </div>
      </ng-template>
    </p-dialog>
  </ng-container>
</div>

<!-- Remove Related Note Confirmation Dialog -->
<p-dialog
  header="Remove Related Note"
  [(visible)]="removeRelatedNoteDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '380px' }"
  [breakpoints]="{ '640px': '95vw' }"
  appendTo="body">
  <p class="text-sm mb-4">
    Remove <strong>{{ removeRelatedNotePendingTitle }}</strong> from Related Notes?
  </p>
  <div class="flex items-center gap-2">
    <input
      type="checkbox"
      id="removeRelatedDeleteBacklink"
      [(ngModel)]="removeRelatedNoteDeleteBacklink"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="!removeRelatedNoteHasBacklink"
      class="cursor-pointer" />
    <label
      for="removeRelatedDeleteBacklink"
      [ngClass]="{ 'opacity-40 cursor-not-allowed': !removeRelatedNoteHasBacklink, 'cursor-pointer': removeRelatedNoteHasBacklink }"
      class="text-sm select-none">
      Delete backlink
      <span *ngIf="!removeRelatedNoteHasBacklink" class="text-surface-400 ml-1">(no backlink exists)</span>
    </label>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="removeRelatedNoteDialogVisible = false">
    </p-button>
    <p-button
      label="Remove"
      severity="danger"
      (onClick)="confirmRemoveRelatedNote()">
    </p-button>
  </ng-template>
</p-dialog>

<!-- Similar Notes Dialog -->
<p-dialog
  header="Similar Notes"
  [(visible)]="similarNotesDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw', maxWidth: '900px' }"
  [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
  <ng-template pTemplate="content">
    <div *ngIf="similarNotesError" class="text-red-600 mb-3 text-sm">{{ similarNotesError }}</div>
    <p-table
      [value]="similarNotesResults"
      [loading]="similarNotesLoading"
      styleClass="p-datatable-sm"
      [paginator]="similarNotesResults.length > 15"
      [rows]="15">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:30%">ID</th>
          <th style="width:45%">Title</th>
          <th style="width:25%">Modified</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="hover:bg-blue-50 dark:hover:bg-blue-900/30">
          <td class="text-xs text-gray-500 truncate max-w-xs" title="{{ getSimilarNoteId(item) }}">{{ getSimilarNoteId(item) }}</td>
          <td class="font-medium">
            <a [routerLink]="['/view', getSimilarNoteId(item)]" target="_blank" rel="noopener" class="hover:underline cursor-pointer">{{ item.title || '-' }}</a>
          </td>
          <td class="text-sm text-gray-500 whitespace-nowrap">{{ formatSimilarNoteDate(item) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center text-gray-500 py-6">
            <span *ngIf="!similarNotesLoading">No similar notes found.</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>
